module.exports = "<app-edu-detail *ngFor=\"let edu of itemsFormArray.controls; let i=index\" [index]=\"i\" [edu]=\"edu\" (removed)=\"itemsFormArray.removeAt($event)\">\n</app-edu-detail>\n<button type=\"button\" class=\"btn btn-outline-success btn-sm float-right\" (click)=\"addItem()\">Add another school</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/education-form/education-form.component.html
// module id = ./src/app/main/content/education-form/education-form.component.html
// module chunks = main